import script from "./DataGroupTransferModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataGroupTransferModal.vue?vue&type=script&lang=ts&setup=true"

import "./DataGroupTransferModal.vue?vue&type=style&index=0&id=734b1894&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734b1894"]])

export default __exports__